export default function (text='') {
  return text.replace(/\r?\n|\r/g, " ")
}
